import { getResours } from "../services/requests";

const showMoreStyles = (trigger, wrapper) => {
  // взаимодействие с картинками через html
  // const cards = document.querySelectorAll(styles),
  //   btn = document.querySelector(trigger);

  // cards.forEach(card => {
  //   card.classList.add('animated', 'fadeInUp');
  // });

  // btn.addEventListener('click', () => {
  //   cards.forEach(card => {
  //     card.classList.remove('hidden-lg', 'hidden-md', 'hidden-sm', 'hidden-xs');
  //     card.classList.add('col-sm-3', 'col-sm-offset-0', 'col-xs-10', 'col-xs-offset-1');
  //   });

  //   btn.remove();
  // });

  // взаимодействие с картинками через backend-часть
  const btn = document.querySelector(trigger);

  btn.addEventListener('click', function () {
    // через json-server
    // getResours('http://localhost:3000/styles')
    //   .then(res => createCards(res))
    //   .catch(error => console.log(error));
    // через файл json
    getResours('assets/db.json')
      .then(res => createCards(res.styles))
      .catch(error => console.log(error));
    this.remove();
  });

  function createCards(response) {
    response.forEach(({ src, title, link }) => {
      let card = document.createElement('div');
      card.classList.add('col-sm-3', 'col-sm-offset-0', 'col-xs-10', 'col-xs-offset-1', 'animated', 'fadeInUp');
      card.innerHTML =
        `
          <div class='styles-block'>
            <img src='${src}' alt>
            <h4>${title}</h4>
            <a href="${link}">Подробнее</a>
          </div>
        `;

      document.querySelector(wrapper).append(card);
    });
  }
};

export default showMoreStyles;